import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ArrowLeft } from 'lucide-react';
import { Card, Button } from '../../components/v2/V2Components';

/**
 * ComingSoon (V2)
 * Placeholder shown when a feature-flagged route is visited while its flag is
 * off. Rendered inside LayoutV2 so the sidebar stays available to navigate away.
 */
const ComingSoon = ({ title = 'This feature' }) => {
    const navigate = useNavigate();

    return (
        <div className="flex items-center justify-center min-h-[60vh]">
            <Card className="p-10 max-w-md w-full text-center">
                <div className="w-14 h-14 mx-auto mb-5 rounded-2xl bg-[var(--primary-bg)] flex items-center justify-center">
                    <Sparkles size={26} className="text-[var(--primary)]" />
                </div>
                <h1 className="font-headline font-bold text-2xl text-[var(--text-main)] mb-2">
                    {title} is coming soon
                </h1>
                <p className="text-sm text-[var(--text-secondary)] mb-7">
                    We&apos;re still putting the finishing touches on this. Check back shortly.
                </p>
                <Button variant="secondary" leadingIcon={ArrowLeft} onClick={() => navigate('/dashboard')}>
                    Back to dashboard
                </Button>
            </Card>
        </div>
    );
};

export default ComingSoon;
